<template>
  <div class="div_vSelect_cadastro">
    <span class="input-label" style="font-size: 12px">Banco:</span
    ><span class="input-label error" v-if="error"> Campo obrigatório!</span><br />
    <v-select
      :options="items"
      label="label"
      v-model="content"
      :class="{ 'vselect--error': error }"
    >
    </v-select>
  </div>
</template>

<script>
"use strict";

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import FirebaseHelper from "../FirebaseHelper";

export default {
  components: {
    vSelect,
  },
  props: {
    error: {
      type: Boolean,
      default: false,
    },
    value: "",
  },
  data() {
    return {
      items: [],
      firebaseHelper: new FirebaseHelper(),
      content: null,
    };
  },
  watch: {
    content(val) {
      if (val) {
        let banco = val.label.split("-");
        this.$emit("input", { id: val.value, codigo: banco[0], descricao: banco[1] });
      }
    },
  },
  created() {
    this.getListaBancos();
    this.$root.$on("reset_banco_selecionado", () => {
      this.content = null;
    });
  },
  mounted() {
    if (this.value) {
      this.content = this.value;
    }
  },
  methods: {
    async getListaBancos() {
      if (!sessionStorage.listaBancos || sessionStorage.listaBancos === "") {
        let response = await this.firebaseHelper.listaBancos();
        if (!response.data.sucesso) {
        } else {
          this.items = response.data.response.map((p) => {
            return { value: p.id, label: `${p.codigo}-${p.descricao}` };
          });
          sessionStorage.listaBancos = JSON.stringify(this.items);
        }
      } else {
        this.items = JSON.parse(sessionStorage.listaBancos);
      }
    },
  },
};
</script>

<style scoped>
.vSelectHeader {
  font-size: 10px !important;
}

span.vs__selected {
  font-size: 11px !important;
}

.v-select {
  margin-top: 0px;
}

.error {
  font-size: 12px;
  color: #ca1919e5;
}
</style>
